import {createListenerMiddleware} from "@reduxjs/toolkit";
import {setAppGlobalError, setAppNotification} from "../slices/globalSlice";

const globalErrorListenerMiddleware = createListenerMiddleware();

globalErrorListenerMiddleware.startListening({
    predicate: (action, currentState) => {
        if (currentState.global.appGlobalError) return false;

        if (action.type === 'user/getUserInfo/rejected') {
            return true;
        }

        return false;
    },
    effect: (action, listenerApi) => {
        listenerApi.dispatch(setAppGlobalError({
            code: null,
            message: [action.error.message || '', action.error.stack || '', action.payload?.message || '', action.payload?.response?.request?.responseURL || ''].filter(error => error).join("<br />")
        }));
        listenerApi.cancelActiveListeners();
    },
});

globalErrorListenerMiddleware.startListening({
    predicate: (action) => action.type === "global/setAppNotification" && action.payload,
    effect: async (_, {dispatch, delay, cancelActiveListeners}) => {
        // Cancel any in-progress instances of this listener
        cancelActiveListeners();

        await delay(100);
        dispatch(setAppNotification(undefined));
    }
});

export default globalErrorListenerMiddleware;